import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  feedbackData = [
    {
      name: 'श्री राज चंदेल',
      location: 'इंदौर',
      system: '3 kW On-Grid Rooftop Solar',
      category: 'Residential',
      rating: 5,
      image: 'assets/image/RE.png',
      feedback:
        'SolarCiti की टीम ने हमारे घर पर 3 kW का On-Grid Solar System बहुत अच्छे तरीके से इंस्टॉल किया। पूरी प्रक्रिया में टीम का व्यवहार, इंस्टॉलेशन की गुणवत्ता और समय पर काम पूरा करने का तरीका बहुत अच्छा रहा। सोलर लगाने के बाद बिजली के बिल शून्य होने के साथ अतिरिक्त बिजली की राशि बिल में समायोजित भी हो रही है।'
    },
    {
      name: 'देपालपुर मोटर्स',
      location: 'देपालपुर',
      system: '6 kW On-Grid Rooftop Solar',
      category: 'Commercial',
      rating: 5,
      image: 'assets/image/RE.png',
      feedback:
        'SolarCiti से सोलर लगवाने का हमारा अनुभव बहुत अच्छा रहा। टीम ने सिस्टम के बारे में पूरी जानकारी सरल भाषा में समझाई और इंस्टॉलेशन भी व्यवस्थित तरीके से किया। अब हमारे वर्कशॉप की बिजली की जरूरत का बड़ा हिस्सा सोलर से पूरा हो रहा है।'
    },
    {
      name: 'श्री सचिन पटेल',
      location: 'पूर्वाड़ा जुन्नार्दा, सुपर कॉरिडोर, इंदौर',
      system: '5 kW Hybrid Solar System',
      category: 'Residential',
      rating: 5,
     image: 'assets/image/RE.png',
      feedback:
        'हमने अपने घर के लिए Hybrid Solar System लगवाया है। SolarCiti की टीम ने सिस्टम की कार्यप्रणाली और बैकअप की पूरी जानकारी दी। बिजली जाने पर बैकअप मिलने से काफी सुविधा हो गई है। इंस्टॉलेशन की क्वालिटी और टीम की सर्विस से हम संतुष्ट हैं।'
    },
    {
      name: 'श्री आनंद मोदी',
      location: 'हातोद, इंदौर',
      system: '6 kW On-Grid Rooftop Solar',
      category: 'Residential',
      rating: 5,
    image: 'assets/image/RE.png',
      feedback:
        'SolarCiti ने हमारे घर पर सोलर प्लांट का काम बहुत प्रोफेशनल तरीके से किया। स्ट्रक्चर, वायरिंग और पैनल इंस्टॉलेशन में अच्छी फिनिशिंग देखने को मिली। टीम ने हर स्टेप पर सही जानकारी दी और काम समय पर पूरा किया। सोलर के बाद बिजली के खर्च में अच्छी बचत हो रही है।'
    },
    {
      name: 'श्रीनाथ स्वीट्स',
      location: 'AB रोड, मांगलिया बायपास, इंदौर',
      system: '10 kW On-Grid Solar System',
      category: 'Commercial',
      rating: 5,
      image: 'assets/image/RE.png',
      feedback:
        'हमारे व्यावसायिक प्रतिष्ठान के लिए SolarCiti द्वारा 10 kW का On-Grid Solar System इंस्टॉल किया गया। पूरी टीम ने साइट सर्वे से लेकर इंस्टॉलेशन और सिस्टम कमीशनिंग तक बेहतरीन समन्वय के साथ काम किया। सिस्टम की परफॉर्मेंस अच्छी है और बिजली खर्च को कम करने में काफी मदद मिल रही है।'
    },
    {
      name: 'श्री प्रदीप बघेल',
      location: 'एयरपोर्ट, इंदौर',
      system: '3 kW Hybrid Solar System',
      category: 'Residential',
      rating: 5,
      image: 'assets/image/RE.png',
      feedback:
        'घर के लिए Hybrid Solar System लगवाने के लिए हमने SolarCiti को चुना और हमारा अनुभव बहुत अच्छा रहा। टीम ने हमारी जरूरत के अनुसार सिस्टम समझाया और इंस्टॉलेशन साफ-सुथरे तरीके से किया। बिजली कटौती के समय बैकअप मिलना हमारे लिए सबसे बड़ी सुविधा है।'
    },
    {
      name: 'श्री जगदीश सिसोदिया',
      location: 'इंदौर',
      system: '8 kW On-Grid Rooftop Solar',
      category: 'Residential',
      rating: 5,
     image: 'assets/image/RE.png',
      feedback:
        'SolarCiti की सर्विस और इंस्टॉलेशन क्वालिटी से हम काफी प्रभावित हुए। टीम समय पर साइट पर आई और पूरे सिस्टम को व्यवस्थित तरीके से इंस्टॉल किया। हमें सोलर सिस्टम की मॉनिटरिंग और परफॉर्मेंस की भी जानकारी दी गई। कुल मिलाकर हमारा अनुभव बहुत संतोषजनक रहा।'
    },
    {
      name: 'श्री साईंकृपा डेयरी',
      location: 'एयरपोर्ट रोड, इंदौर',
      system: '10 kW On-Grid Solar System',
      category: 'Commercial',
      rating: 5,
      image: 'assets/image/RE.png',
      feedback:
        'हमारे व्यावसायिक परिसर में 10 kW का On-Grid Solar System SolarCiti द्वारा लगाया गया। टीम ने प्रोजेक्ट को प्रोफेशनल तरीके से मैनेज किया और इंस्टॉलेशन के दौरान सुरक्षा एवं गुणवत्ता का विशेष ध्यान रखा। सोलर सिस्टम के माध्यम से हमारी बिजली लागत को कम करने में अच्छी मदद मिल रही है। SolarCiti की टीम को हम निश्चित रूप से recommend करेंगे।'
    }
  ];
}
